import { useState } from "react";
import ToolkitAppScroller from "components/BeyondToolkit/ToolkitAppScroller";
import ToolkitFullscreenAudioPlayer from "components/ToolkitFullscreenAudioPlayer";
import ToolkitGridItem from "components/ToolkitGridItem";
import { BedtimeStoryEpisode, episodes } from "data/bedtimeStoryEpisodes";
import { closeWebview } from "src/pods/webviewInit";
import { logParentToolkitEvent } from "src/utils/logEvent";
import { BEDTIME_STORIES } from "utils/beyondToolkitTools";
import { useQuotaActivity } from "src/pages/beyondToolkit/useQuotaActivity.vm";
import styles from "./index.module.css";

const useVmDefault = () => useQuotaActivity("bedtimeStories");

type BedtimeStoriesProps = {
  di?: { useVm?: typeof useVmDefault };
};

function BedtimeStories({ di }: BedtimeStoriesProps) {
  const useVm = di?.useVm ?? useVmDefault;
  const { recordUsage } = useVm();

  const [episodeSelected, setEpisodeSelected] = useState<BedtimeStoryEpisode | null>(null);
  const [quotaReached, setQuotaReached] = useState(false);

  const { title, imgSrc } = BEDTIME_STORIES();
  const availableEpisodes = episodes().filter((episode) => {
    const isEpisodePastReleaseDate = !!episode.releaseDate && episode.releaseDate < new Date();
    const isOriginalReleasedEpisode = !episode.releaseDate;
    return isOriginalReleasedEpisode || isEpisodePastReleaseDate;
  });

  return (
    <div>
      {episodeSelected == null ? (
        <ToolkitAppScroller title={title} variant="bedtimeStories" imgSrc={imgSrc}>
          <div className={styles.grid}>
            {availableEpisodes.map((episode, i) => {
              return (
                <ToolkitGridItem
                  key={i}
                  index={i}
                  title={episode.title}
                  imgSrc={episode.imgSrc}
                  onItemClick={() => {
                    logParentToolkitEvent({ eventName: `bedtime.${episode.loggingId}.tap` });
                    setEpisodeSelected(episode);
                  }}
                />
              );
            })}
          </div>
        </ToolkitAppScroller>
      ) : (
        <ToolkitFullscreenAudioPlayer
          audioSrc={episodeSelected.audioSrc}
          imgSrc={episodeSelected.fullscreenImgSrc}
          onClose={() => {
            setEpisodeSelected(null);
            if (quotaReached) {
              closeWebview();
            }
          }}
          sendUsage={async () => {
            const { exhausted } = await recordUsage();
            if (exhausted) setQuotaReached(true);
          }}
        />
      )}
    </div>
  );
}

export default BedtimeStories;
